// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nsc-additional[data-v-311aff1f]{padding-left:.5em}.nsc-radio-option.nsc-radio-option-label[data-v-311aff1f]{font-weight:400!important}", ""]);
// Exports
module.exports = exports;
